import { lazy } from 'react'
import ReactGA from 'react-ga4'
import { Helmet } from 'react-helmet'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AuthenticatedRoutes from './src/AuthenticatedRoutes'
import GoogleAuth from './src/components/screens/GoogleAuthScreen'
import LandingScreen from './src/components/screens/LandingScreen'
import SharingUnavailableView from './src/components/views/SharingUnavailableView'
import { GOOGLE_AUTH_ROUTE, LEGACY_SHARING_ROUTES, PRIVACY_POLICY_ROUTE, TERMS_OF_SERVICE_ROUTE } from './src/constants'
import marketingCopy from './src/marketingCopy'
import { GlobalStyle } from './src/styles'
import { CompanyPolicyPages } from './src/utils/enums'

const GA_TRACKING_ID = 'G-GLHZBNMPN9'
ReactGA.initialize(GA_TRACKING_ID, {
    gaOptions: {
        siteSpeedSampleRate: 100,
    },
})

const CompanyPolicyView = lazy(() => import('./src/components/views/CompanyPolicyView'))

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <Helmet>
                <base target="_blank" />
                <meta content={marketingCopy.MARKETING_META_DESCRIPTION} name="description" />
                <meta content={marketingCopy.MARKETING_META_TITLE} property="og:title" />
                <meta content={marketingCopy.MARKETING_SOCIAL_DESCRIPTION} property="og:description" />
                <meta content={marketingCopy.MARKETING_META_TITLE} property="twitter:title" />
                <meta content={marketingCopy.MARKETING_SOCIAL_DESCRIPTION} property="twitter:description" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="/images/futureman.png" />
                <meta content="summary_large_image" name="twitter:card" />
            </Helmet>
            <BrowserRouter>
                <GlobalStyle />

                <Routes>
                    <Route index element={<LandingScreen />} />
                    <Route path="sign-up" element={<LandingScreen />} />
                    <Route path="tos-summary" element={<Navigate to="/" replace />} />
                    <Route
                        path={TERMS_OF_SERVICE_ROUTE}
                        element={<CompanyPolicyView page={CompanyPolicyPages.TermsOfService} />}
                    />
                    <Route
                        path={PRIVACY_POLICY_ROUTE}
                        element={<CompanyPolicyView page={CompanyPolicyPages.PrivacyPolicy} />}
                    />
                    {LEGACY_SHARING_ROUTES.map((route) => (
                        <Route key={route} path={route} element={<SharingUnavailableView />}>
                            <Route path=":itemId" element={<SharingUnavailableView />} />
                        </Route>
                    ))}
                    <Route path={GOOGLE_AUTH_ROUTE} element={<GoogleAuth />} />
                    <Route path="*" element={<AuthenticatedRoutes />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </QueryClientProvider>
    )
}

export default App
